import { get, post, del } from "../assets/functions";

export default {
    namespaced: true,
    state: {
        requests: [],
        settings: {
            enabled: false,
            token: null,
            defaultDuration: 30,
            maxDaysInAdvance: 90,
            minHoursNotice: 24,
            openingHours: {
                monday: {enabled: true, start: '09:00', end: '17:00'},
                tuesday: {enabled: true, start: '09:00', end: '17:00'},
                wednesday: {enabled: true, start: '09:00', end: '17:00'},
                thursday: {enabled: true, start: '09:00', end: '17:00'},
                friday: {enabled: true, start: '09:00', end: '17:00'},
                saturday: {enabled: false, start: '09:00', end: '17:00'},
                sunday: {enabled: false, start: '09:00', end: '17:00'}
            }
        },
        blacklist: []
    },
    mutations: {
        setRequests(state, requests) {
            state.requests = requests;
        },
        setSettings(state, settings) {
            state.settings = settings;
        },
        setBlacklist(state, blacklist) {
            state.blacklist = blacklist;
        },
        updateRequest(state, request) {
            const index = state.requests.findIndex(r => r.id === request.id);
            if (index !== -1) {
                state.requests[index] = request;
            } else {
                state.requests.push(request);
            }
        },
        removeRequest(state, requestId) {
            state.requests = state.requests.filter(r => r.id !== requestId);
        }
    },
    actions: {
        async fetchRequests({ commit }, status = null) {
            const url = status ? `/api/booking-requests?status=${status}` : '/api/booking-requests';
            const response = await get(url);
            if (response && response.status === 'ok') {
                commit('setRequests', response.requests || []);
            }
            return response;
        },
        async acceptRequest({ commit, dispatch }, requestId) {
            const response = await post(`/api/booking-requests/${requestId}/accept`, {});
            if (response && response.status === 'ok') {
                await dispatch('fetchRequests');
            }
            return response;
        },
        async declineRequest({ commit, dispatch }, requestId) {
            const response = await post(`/api/booking-requests/${requestId}/decline`, {});
            if (response && response.status === 'ok') {
                await dispatch('fetchRequests');
            }
            return response;
        },
        async counterPropose({ commit, dispatch }, { requestId, newFrom, newTo }) {
            const response = await post(`/api/booking-requests/${requestId}/counter-propose`, {
                newFrom,
                newTo
            });
            if (response && response.status === 'ok') {
                await dispatch('fetchRequests');
            }
            return response;
        },
        async fetchSettings({ commit }) {
            const response = await get('/api/booking-requests/settings');
            if (response && response.status === 'ok') {
                commit('setSettings', response.settings || {});
            }
            return response;
        },
        async updateSettings({ commit }, settings) {
            const response = await post('/api/booking-requests/settings', settings);
            if (response && response.status === 'ok') {
                commit('setSettings', response.settings || {});
            }
            return response;
        },
        async generateToken({ commit, dispatch }) {
            const response = await post('/api/booking-requests/settings/generate-token', {});
            if (response && response.status === 'ok') {
                commit('setSettings', response.settings || {});
            }
            return response;
        },
        async fetchBlacklist({ commit }) {
            const response = await get('/api/booking-requests/blacklist');
            if (response && response.status === 'ok') {
                commit('setBlacklist', response.blacklist || []);
            }
            return response;
        },
        async addToBlacklist({ commit, dispatch }, email) {
            const response = await post('/api/booking-requests/blacklist', { email });
            if (response && response.status === 'ok') {
                commit('setBlacklist', response.blacklist || []);
            }
            return response;
        },
        async removeFromBlacklist({ commit, dispatch }, blacklistId) {
            const response = await del(`/api/booking-requests/blacklist/${blacklistId}`);
            if (response && response.status === 'ok') {
                commit('setBlacklist', response.blacklist || []);
            }
            return response;
        }
    }
};


